<script>
import moment from 'moment';
import API from '../services/api';

const api = new API();

module.exports = {
  template : '#car-searches-template',
  computed : {
    searches : function() {
      if (this.$store.state.carSearches)
        return {
          list  : this.$store.state.carSearches,
          total : this.$store.state.carSearches.length
        };
      else return false;
    }
  },
  methods : {
    removeSearch : function(id) {
      api.removeCarSearch({ id : id });

      this.$store.state.carSearches = this.$store.state.carSearches.reduce((result, search) => {
        if (search.id != id) result.push(search);

        return result;
      }, []);
    }
  }
};
</script>